// ############################ Styles ###########################
// tslint:disable:variable-name

import styled from 'styled-components';
import Popup from '../popup/Popup';
import Subtitle from '../onlineSubtitle/onlineSubtitle';

// ############################ Imported from Old UI ###########################

export const SVerificationCodeSent = styled.h3<{}>(
  ({ theme }) => `
  font-weight: ${theme.font.weight.bold};
  color: ${theme.colors.grayDark};
  margin-bottom: ${theme.spacing.larger}px;
  text-align: center;
  font-size: ${theme.font.size.medium2};
  @media only screen and (min-width: 800px) {
    font-size: ${theme.font.size.large};
  }
`
);

export const SMessage = styled.p<{}>(
  ({ theme }) => `
  font-weight: ${theme.font.weight.light};
  color: ${theme.colors.grayDark};
  margin-bottom: ${theme.spacing.larger}px;
  text-align: center;
  line-height: ${theme.spacing.larger + 5}px;
  font-size: ${theme.font.size.medium};
  @media only screen and (min-width: 800px) {
    font-size: ${theme.font.size.medium2};
  }
`
);

export const SMessageError = styled(SMessage as any)<{}>(
  ({ theme }) => `
  color: ${theme.colors.error};
`
);

export const SHelp = styled.p<{}>(
  ({ theme }) => `
  font-size: ${theme.font.size.smallMedium};
  font-weight: ${theme.font.weight.light};
  color: ${theme.colors.grayDark};
  margin-bottom: ${theme.spacing.larger}px;
  text-align: center;
`
);

export const SCodeSection = styled.section(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: theme.spacing.larger2,
  marginBottom: theme.spacing.larger2,
}));

export const SActionsSection = styled.section(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const SEdiv = styled.div<{}>(
  ({ theme }) => `
    text-align: center;
    font-size: 22px;
    font-weight: 300;
    margin-right: 20px;
    line-height: 45px;
    font-weight: 400;
    color: ${theme.colors.grayDark}`
);

export const SPopup = styled(Popup)(
  () => `
  width: 340px;
  height: 600px;
  @media only screen and (max-width: 800px) {
    width: 100%;
    z-index: 200;
    height: 100%;
  }
  &.long-pincode-popup {
    width: 455px;
    height: 526px;
  }
`
);

export const SSubtitle = styled(Subtitle)(
  () => `
  align-items: left;
  text-align: left;
  font-size: 14px;
  line-height: 1.78;
  padding: 0 4px;
  &.long-pincode-subtitle {
    text-align: center;
    margin-top: 90px;
  }
`
);

export const SCenteredSubtitle = styled(Subtitle)(
  () => `
  align-items: center;
  text-align: center;
  font-size: 14px;
  line-height: 1.78;
  padding: 0 4px;
`
);

export const SCodeNotReceivedSection = styled.span(
  ({ theme }) => `
  font-size: 14px;
  margin-top: 12px;
  color: ${theme.colors.mediumGray};
  font-family: Poppins;
`
);

export const SCodeNotReceivedButton = styled.span<{ isActive: boolean; }>(
  ({ theme, isActive }) => `
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  font-size: 14px;
  font-family: Poppins;
  color: ${theme.colors.primaryDark2};

  ${isActive && `
    color: ${theme.colors.primaryBright};
    text-decoration: underline;
    cursor: pointer;
  `}
`
);

export const SCodeNotReceivedTimer = styled.span(
  ({ theme }) => `
  font-size: 14px;
  margin-top: 12px;
  color: ${theme.colors.mediumGray};
  font-family: Poppins;
`
);
